import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import "../../stylesheets/main.scss";

import "./Impressum.scss";

// components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import InfoArea from "../../components/InfoArea/InfoArea";

// setup
import setup from "../../../setup/index.json";

// data
import dataSta from "./data/01-sta-altona.json";
import dataHeh from "./data/02-heh-treuhand.json";
const data = setup.dist === "sta-altona" ? dataSta : dataHeh;

// sta and heh config map
import config from "../../index.json";
const pageData = config[data.pagename];
const templateName = `${data.pagename}-impressum`;

function Impressum() {
  return (
    <div className={`${templateName}`}>
      {data.title && (
        <Helmet>
          <title>
            {pageData.title} - {data.title}
          </title>
        </Helmet>
      )}
      <div className={`${data.pagename}-bg`}>
        {data.claim && (
          <span className={`${data.pagename}-claim`}>{data.claim}</span>
        )}
      </div>
      <Header homeLink noLinks pagename={data.pagename} />
      <div className={`${data.pagename}-content`}>
        <InfoArea visible pagename={data.pagename}>
          <div className={`${templateName}__content`}>
            <h2 className={`${templateName}__headline`}>Impressum</h2>
            <span>Angaben gemäß § 5 TMG:</span>
            <h3 className={`${templateName}__subheadline`}>Kontakt </h3>
            <p>
              <span>{data.company}</span>
              <span>{data.address}</span>
              <span>{data.zip}</span>
            </p>
            <p>
              <span>Telefon: {data.phone}</span>
              <span>Telefax: {data.fax}</span>
              <span>
                Mail: <a href={`mailto:${data.mail}`}>{data.mail}</a>
              </span>
            </p>
            <span>{data.page}</span>
            <br />
            <h3 className={`${templateName}__subheadline`}>Geschäftsführer:</h3>
            <span>{data.executiveDirector}</span>
            <h3 className={`${templateName}__subheadline`}>Registergericht:</h3>
            <span>
              {data.court} {data.hra}
            </span>
            <span>
              {data.company} {data.hrb}
            </span>
            <p>{data.id && <span>USt-IdNr. {data.id}</span>}</p>
            <p>{data.openingHours && <span>{data.openingHours}</span>}</p>
            {data.imageSource && (
              <React.Fragment>
                <h3 className={`${templateName}__subheadline`}>
                  Quellenangaben für die verwendeten Bilder und Grafiken:
                </h3>
                <span>
                  <a
                    href="http://www.skyline-panorama.de/"
                    target="_blank"
                    rel="nofollow"
                  >
                    http://www.skyline-panorama.de
                  </a>
                </span>
              </React.Fragment>
            )}
            <h3 className={`${templateName}__subheadline`}>
              Haftungsausschluss Inhalte des Webangebotes
            </h3>
            <p>
              Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG
              f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir
              als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte
              oder gespeicherte fremde Informationen zu &uuml;berwachen oder
              nach Umst&auml;nden zu forschen, die auf eine rechtswidrige
              T&auml;tigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst
              ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
              m&ouml;glich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
            <h3 className={`${templateName}__subheadline`}>
              Haftungsausschluss Inhalte externer Links
            </h3>
            <p>
              Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir
              f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr
              &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist
              stets der jeweilige Anbieter oder Betreiber der Seiten
              verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
              Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e
              &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
              derartige Links umgehend entfernen.
            </p>
            <h3 className={`${templateName}__subheadline`}>Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes
              bed&uuml;rfen der schriftlichen Zustimmung des jeweiligen Autors
              bzw. Erstellers. Downloads und Kopien dieser Seite sind nur
              f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
              wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
              werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
              trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend
              entfernen.
            </p>
            <br />
            <p>
              Quelle: <a href="https://www.e-recht24.de">e-recht24.de</a>
            </p>
          </div>
        </InfoArea>
      </div>
      {data.footer && <Footer {...data.footer} pagename={data.pagename} />}
    </div>
  );
}

ReactDOM.render(<Impressum />, document.getElementById("app"));
